import {
  ModalBasic,
  Logic,
  MultipleSelectCheckmarks,
  TextArea,
  FileLoader,
  MultiSetMenu
} from '@root/components';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import operations from '@root/redux/admin/admin-operation';
import 'react-quill/dist/quill.snow.css';
import { MultiList } from '@root/components/MultiList/MultiList';
import { serialize } from 'object-to-formdata';

export const FormCourse = ({ handleClose, initData, options }) => {
  const [data, setData] = useState({
    title: '',
    lvl: '',
    description: '',
    modules: [],
    count_video: '',
    course_duration: '',
    per_week: '',
    suitable_for_those_who: [],
    course_overview: []
  });
  const [about, setAbout] = useState('');
  const [talking, setTalking] = useState('');
  const [courseLogo, setCourseLogo] = useState(false);
  const [error, setError] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (initData) {
      const {
        name,
        description,
        lvl,
        modules,
        about,
        talking,
        count_video,
        course_duration,
        per_week,
        suitable_for_those_who = [],
        course_overview = [],
        course_logo,
      } = initData;
      setAbout(about)
      setTalking(talking)
      if (course_logo?.path) setCourseLogo(course_logo)
      setData({
        title: name,
        description,
        lvl,
        modules,
        count_video,
        course_duration,
        per_week,
        suitable_for_those_who,
        course_overview
      });
    }
  }, [initData]);

  const handelSubmit = e => {
    e.preventDefault();
    if (!validation()) {
      const {
        title,
        lvl,
        description,
        modules,
        count_video,
        course_duration,
        per_week,
        suitable_for_those_who,
        course_overview
      } = data;

      if (initData) {
        let dataST = {
          name: title,
          description,
          lvl,
          modules,
          about,
          talking,
          count_video,
          course_duration,
          per_week,
          suitable_for_those_who,
          course_overview,
        };

        if (!courseLogo?._id) {
          dataST = { ...dataST, course_logo: courseLogo };
        }

        const sendDate = serialize(
          {
            ...dataST
          },
          {
            indices: true,
            nullsAsUndefineds: true,
            booleansAsIntegers: true,
            noFilesWithArrayNotation: true,
          },
        )
        dispatch(
          operations.updateCourse({ courseId: initData._id, sendDate }),
        ).then(() => {
          handleClose();
        })
      } else {
        const sendDate = serialize(
          {
            name: title,
            description,
            lvl,
            modules,
            about,
            talking,
            count_video,
            course_duration,
            per_week,
            suitable_for_those_who,
            course_overview,
            course_logo: courseLogo,
          },
          {
            indices: true,
            nullsAsUndefineds: true,
            booleansAsIntegers: true,
            noFilesWithArrayNotation: true,
          },
        );
        dispatch(
          operations.createCourse(sendDate),
        ).then(() => {
          handleClose();
        })
      }

    }
  };

  const handelDelete = e => {
    dispatch(operations.deleteCourse({ courseId: initData._id }));
    handleClose();
  };

  const validation = () => {
    const { title, lvl, count_video, course_duration, per_week } = data;
    if (!title || title === '') {
      setError({ title: { init: true, text: 'Title is required' } });
      return true;
    }

    if (!lvl || lvl === '') {
      setError({ lvl: { init: true, text: 'Lvl is required' } });
      return true;
    }
    if (!count_video || count_video === '') {
      setError({ count_video: { init: true, text: 'Count video is required' } });
      return true;
    }
    if (!course_duration || course_duration === '') {
      setError({ course_duration: { init: true, text: 'Course duration is required' } });
      return true;
    }
    if (!per_week || per_week === '') {
      setError({ per_week: { init: true, text: 'Number of classes per week is required' } });
      return true;
    }
    if (!courseLogo || courseLogo === '') {
      setError({ courseLogo: { init: true, text: 'Сourse logo is required' } });
      return true;
    }
    if (!description || description === '') {
      setError({ description: { init: true, text: 'Сourse logo is required' } });
      return true;
    }

    setError({});
    return false;
  };

  const onInputChange = e => {

    setData({ ...data, [e.target.name]: e.target.value });
  };

  const changeModules = arr => setData({ ...data, modules: [...arr] });

  const onChangeIterableList = (name) => (value, idx) => {
    const copy = [...data[name]]
    copy[idx] = value
    setData({ ...data, [name]: copy })

  }

  const onDeleteItemFromIterableList = (name) => (idx) => {
    const copy = [...data[name]]

    if (idx === 0) {
      copy.shift()
    } else {
      copy.splice(idx, idx)
    }

    setData({ ...data, [name]: copy })
  }

  const {
    title,
    lvl,
    description,
    modules,
    count_video,
    course_duration,
    per_week,
    suitable_for_those_who,
    course_overview
  } = data;

  return (
    <>
      <ModalBasic handleClose={handleClose}>
        <Form onSubmit={handelSubmit}>
          <Title>{initData ? 'Edit' : 'Create'} the Course</Title>
          <FormContext>
            <WrapperForm>
              <TextField
                error={error?.title?.init}
                helperText={error?.title?.text}
                id="outlined-basic"
                label="Title*"
                variant="outlined"
                name="title"
                value={title}
                onInput={onInputChange}
                size="small"
                margin="dense"
                sx={{ width: '100%' }}
              />

              <TextArea
                value={about}
                onChange={setAbout}
                placeholder={'Enter an About'}
                label={'About'}
              />

              <TextField
                error={error?.lvl?.init}
                helperText={error?.lvl?.text}
                id="outlined-basic"
                label="LvL*"
                variant="outlined"
                name="lvl"
                value={lvl}
                onInput={onInputChange}
                size="small"
                margin="dense"
                sx={{ width: '100%' }}
              />
              <FileLoader
                title={'Завантажити лого курсу'}
                file={courseLogo}
                setFile={setCourseLogo}
                error={error?.courseLogo}
              />
              <TextField
                error={error?.description?.init}
                helperText={error?.description?.text}
                id="outlined-basic"
                label="Description*"
                variant="outlined"
                name="description"
                value={description}
                onInput={onInputChange}
                size="small"
                margin="dense"
                sx={{ width: '100%' }}
              />

              <MultipleSelectCheckmarks
                name={'Modules'}
                data={options.modules}
                currentId={modules}
                fetchValue={changeModules}
                width={400}
              />

              <TextField
                error={error?.count_video?.init}
                helperText={error?.count_video?.text}
                id="outlined-basic"
                label="Count of Video*"
                variant="outlined"
                name="count_video"
                value={count_video}
                onInput={onInputChange}
                size="small"
                margin="dense"
                sx={{ width: '100%' }}
              />
              <TextField
                error={error?.course_duration?.init}
                helperText={error?.course_duration?.text}
                id="outlined-basic"
                label="Duration of the course*"
                variant="outlined"
                name="course_duration"
                value={course_duration}
                onInput={onInputChange}
                size="small"
                margin="dense"
                sx={{ width: '100%' }}
              />

              <TextField
                error={error?.per_week?.init}
                helperText={error?.per_week?.text}
                id="outlined-basic"
                label="Number of classes per week*"
                variant="outlined"
                name="per_week"
                value={per_week}
                onInput={onInputChange}
                size="small"
                margin="dense"
                sx={{ width: '100%' }}
              />
              <Wrapper>
                <MultiList
                  value={suitable_for_those_who}
                  onChange={onChangeIterableList('suitable_for_those_who')}
                  onDelete={onDeleteItemFromIterableList('suitable_for_those_who')}
                  label={"Suitable for those who"}
                />
              </Wrapper>
              <Wrapper>
                <MultiList
                  value={course_overview}
                  onChange={onChangeIterableList('course_overview')}
                  onDelete={onDeleteItemFromIterableList('course_overview')}
                  label={"Course overview"}
                />
              </Wrapper>

              <TextArea
                value={talking}
                onChange={setTalking}
                placeholder={'Enter a Talking'}
                label={'Talking'}
              />
            </WrapperForm>
          </FormContext>

          <Logic data={initData} handelDelete={handelDelete} />
        </Form>
      </ModalBasic>
    </>
  );
};

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  margin-top: 10px;

  flex: 1 1 0;

  .ql-container {
    min-height: 70px;
    max-height: 70px
   }
`;

const FormContext = styled.div`
  margin: 20px -20px 20px 0; 
  
`
const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  margin-right: 20px;
`

const Title = styled.strong`
  display: block;
  font-size: 18px;
  line-height: 1;
`;

const Wrapper = styled.div`
  margin: 10px;
  width: 100%;
`;

